import {GuideLevelModelV2} from 'resources/GeneratedModels/GuideLevel/GuideLevelModel.v2';
import {extensions} from './guideLevel.extensions';
import {validators} from './guideLevel.validators';

GuideLevelModelV2.extend(extensions);
GuideLevelModelV2.addValidators(validators);

export {GuideLevelModelV2};
